import React, { useEffect, useState } from "react";
import { getEngagementDetail, getInspectionActivities } from "../../helpers/backend_helper";
import { Modal, ModalBody, ModalHeader } from "../../components/Common/AppOverlay";

export default function ReviewHeaderActions({ review, discussionAction, onClose, onEngagement, onActivities, activityCount }) {
  const [activities, setActivities] = useState([]);
  const [panel, setPanel] = useState(null);
  const [engagement, setEngagement] = useState(review.engagementDetail);
  const [error, setError] = useState("");
  useEffect(() => {
    if (onActivities) return;
    let active = true;
    getInspectionActivities(review.id).then((response) => { if (active && response?.status) setActivities(response.data || []); }).catch(() => {});
    return () => { active = false; };
  }, [review.id, Boolean(onActivities)]);
  const openEngagement = async () => {
    if (onEngagement) return onEngagement();
    setPanel("engagement"); setError("");
    try {
      const response = await getEngagementDetail(review.engagementId || review.engagementDetail?.id);
      if (!response?.status) throw new Error(response?.message || "Unable to load engagement.");
      setEngagement(response.data);
    } catch (failure) { setError(failure.message); }
  };
  const count = activityCount ?? activities.length;
  return <>
    <button type="button" className="checklist-review__top-link" onClick={openEngagement} disabled={!(review.engagementId || review.engagementDetail?.id)} aria-haspopup="dialog">View Engagement</button>
    <button type="button" className="checklist-review__top-link" onClick={() => { if (onActivities) onActivities(); else { setError(""); setPanel("activities"); } }} aria-haspopup="dialog">View Activities{count > 0 ? ` (${count})` : ""}</button>
    {discussionAction}
    <button type="button" onClick={onClose}><i className="bx bx-x" /> Close</button>
    <Modal isOpen={Boolean(panel)} toggle={() => setPanel(null)} centered scrollable size="lg">
      <ModalHeader toggle={() => setPanel(null)}>
        {panel === "engagement" ? "Engagement" : "Review Activities"}
      </ModalHeader>
      <ModalBody>
        {error && <p role="alert">{error}</p>}
        {panel === "engagement" ? <dl><dt>Engagement</dt><dd>{engagement?.name || "—"}</dd><dt>Client</dt><dd>{engagement?.client?.clientName || engagement?.clientName || "—"}</dd><dt>Engagement number</dt><dd>{engagement?.engagementNo || "—"}</dd><dt>Description</dt><dd>{engagement?.description || "—"}</dd></dl> : <ul>{activities.map((item) => <li key={item.id}>{item.activityNote}<small> {item.activityDate ? new Date(item.activityDate).toLocaleString() : ""}</small></li>)}{!activities.length && <li>No activities recorded.</li>}</ul>}
      </ModalBody>
    </Modal>
  </>;
}
